import { types } from "@vilocnv/allsetra-core";
import { ObjectIconUpdatedEventDto } from "../dtos/object-icon-updated-event.dto";

export function mapIconUpdatedEventToObject(
  objectIconUpdatedEventData: ObjectIconUpdatedEventDto | undefined,
  object: types.IObject | undefined
): types.IObject | undefined {
  if (!objectIconUpdatedEventData || !object) return;

  const newObject: types.IObject = {
    ...object,
    objectType: {
      ...object.objectType,
      icon: {
        ...object?.objectType?.icon,
        ...(objectIconUpdatedEventData.iconUrl !== undefined && {
          url: objectIconUpdatedEventData.iconUrl
        })
      }
    }
  };

  return newObject;
}
